require('isomorphic-fetch');
require('babel-polyfill');
require('url-polyfill');
